module.exports = __webpack_public_path__ + "static/img/p1.51d8eb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robot/LM4/p1.jpg
// module id = ElSu
// module chunks = 7